
import { computed, defineComponent, ref, Ref, watch } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'Pagination',
  props: {
    totalPages: {
      type: Number,
      default: 1,
      required: true
    }
  },
  setup(props) {
    const route = useRoute()
    const currentPage = computed(() => Number(route.query.page) || 1)
    const allPages = computed(() =>
      [...Array(props.totalPages).keys()].map((n) => n + 1)
    )
    const go = (num: number) => ({
      query: { ...route.query, page: currentPage.value + num }
    })
    const push = (num: number) => ({
      query: { ...route.query, page: num }
    })
    const pagenationNums: Ref<number[]> = ref([])
    const maxDisplayPageNum = 5 //最大ページネーション数
    const halfDisplayPageNum = Math.floor(maxDisplayPageNum / 2)

    watch(
      () => [currentPage.value, allPages.value],
      () => {
        // ページ数が、最大ページング表示数以下であれば全ページそのまま表示
        if (allPages.value.length <= maxDisplayPageNum) {
          pagenationNums.value = allPages.value
          return
        }
        // 現在ページが、最初のページ数から最大ページング表示数の半分の間は
        // ページングは1から最大ページング数を表示
        if (currentPage.value <= allPages.value[halfDisplayPageNum - 1]) {
          pagenationNums.value = allPages.value.slice(0, maxDisplayPageNum)
          return
        }
        // 現在ページが、ページ数最後から最大ページング表示数の半分の間
        // ページングは最終ページから最大ページング数を表示
        if (
          currentPage.value >=
          allPages.value[allPages.value.length - halfDisplayPageNum]
        ) {
          pagenationNums.value = allPages.value.slice(-1 * maxDisplayPageNum)
          return
        }
        // それ以外は
        // 現在ページと、±最大ページング数の半分を表示
        pagenationNums.value = [...Array(maxDisplayPageNum).keys()].map(
          (n) => currentPage.value - halfDisplayPageNum + n
        )
        return
      },
      {
        immediate: true
      }
    )

    const isFirstPage = computed(
      () => currentPage.value === pagenationNums.value[0]
    )
    const isLastPage = computed(
      () =>
        currentPage.value ===
        pagenationNums.value[pagenationNums.value.length - 1]
    )

    return {
      allPages,
      pagenationNums,
      halfDisplayPageNum,
      currentPage,
      isFirstPage,
      isLastPage,
      push,
      go
    }
  }
})
